




























































































































import Checkbox from "@/shared/components/ui/Checkbox.vue";
import Button from "@/shared/components/ui/Button.vue";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import {
  Vue,
  Component,
  Prop,
  Watch
} from "@/shared/vuepack";
import {
  IndividualSignup,
} from "@/shared/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { shouldShowEmployerSignupQuestion } from "@/shared/api/userService";
import { useNotifierStore } from "@/shared/store/notifier";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useUserStore } from "@/shared/store/user";
import { useSignUpStore } from "@/employee/store/signup";

const AvidiaBendPartnerId = "10";

@Component({
  components: {
    Checkbox,
    Button,
    LoginWrapper,
    GenericLoadingSpinner
  }
})
export default class IndividualSignups extends Vue {
  signupStore = useSignUpStore();
  notifierStore = useNotifierStore();
  portalCustomizationStore = usePortalCustomizationStore();
  userStore = useUserStore();

  @Prop() routeToLogin;

  @Prop() partner;

  formModel: IndividualSignup = null;
  submitting = false;
  signupComplete = false;
  showErSignupQuestion = true;

  created () {
    if (!this.formModel) {
      this.formModel = this.signupStore.individualSignupState;
    }
  }

  mounted () {
    this.getPartner();
  }

  @Watch("partner")
  getPartner () {
    shouldShowEmployerSignupQuestion(Number(this.signupPartnerId))
        .then(response => {
          this.showErSignupQuestion = response.data.showEmployerSignupQuestion;
        })
        .catch(() => {/* noop */
        });
  }

  get yesOrNoOptions () {
    return [
      { text: "Yes", value: true },
      { text: "No", value: false },
    ];
  }

  get partnerName () {
    return this.portalCustomizationStore.supportInfo.displayName;
  }

  get erSignupQuestionCopy () {
    return `Are you enrolling in your Employer's HSA program with ${this.partnerName}?`;
  }

  isSubmitDisabled () {
    return this.submitting || !this.portalCustomizationStore.isSupportInfoLoaded;
  }

  get signupPartnerId () {
    return this.partner ? this.partner : AvidiaBendPartnerId;
  }

  onSignup () {
    this.$validator.validateAll().then(isValid => {
      if (!isValid) {
        return;
      }

      this.formModel.partnerId = this.signupPartnerId;
      this.submitting = true;
      this.signupStore.signupIndividual(this.formModel)
          .then(_ => {
            this.signupComplete = true;
            this.notifierStore.setSuccess("Your account has been created successfully");
          })
          .finally(() => {
            this.submitting = false;
          });
    });
  }

  onResendEmail () {
    this.signupStore.resendIndividualSignupEmail({ email: this.formModel.email })
        .then(res => {
          this.notifierStore.setSuccess("Your verification email has been resent");
        });
  }
}
